export default __webpack_public_path__ + "static/media/book-open.7b6bd85a.svg";